import { Controller } from "@hotwired/stimulus"
import { createTimeline, spring } from "animejs"

// Connects to data-controller="admins--components--search-form"
export default class extends Controller {
  static targets = [
    "form",
    "modal",
    "backdrop",
    "customerField",
    "searchIntro",
    "searchField",
    "searchResults",
    "searchSpinner",
    "resetButton",
  ]

  static values = {
    timeout: Number,
    inputField: String
  }

  connect() {
    if (this.hasSearchFieldTarget) {
      this.bookingInputFieldTarget = document.getElementById(this.inputFieldValue)

      this.element.addEventListener("turbo:submit-start", (_) => { this.submitStart() })
      this.element.addEventListener("turbo:submit-end", (_) => { this.submitEnd() })
    }
  }

  disconnect() {
    if (this.hasSearchFieldTarget) {
      this.element.removeEventListener("turbo:submit-start", (_) => { this.submitStart() })
      this.element.removeEventListener("turbo:submit-end", (_) => { this.submitEnd() })
    }
  }

  hideModal(_) {
    this.modalTarget.style.display = "none"
  }

  showModal(_) {
    let timeline = createTimeline({
      defaults: {
        duration: 800,
      },
      loop: false,
      onBegin: () => {
        this.modalTarget.style.display = "flex"
        this.searchFieldTarget.value = ""
        this.searchResultsTarget.classList.add("hidden")
        this.searchIntroTarget.classList.remove("hidden")
      }
    })

    timeline
      .add(this.formTarget, {
        scale: [0.8, 1],
        opacity: [0, 1],
        ease: spring({
          bounce: 0.5,
          duration: 400
        })
      }, 0)
      .add(this.backdropTarget, {
        opacity: [0, 1],
        duration: 200,
        easing: "linear"
      }, 0)
      .then(() => { this.searchFieldTarget.focus() })

    timeline.play()
  }

  select(event) {
    let userId = event.currentTarget.dataset.userId
    let label = event.currentTarget.dataset.userLabel

    this.searchFieldTarget.value = label
    this.bookingInputFieldTarget.value = userId
    this.customerFieldTarget.innerHTML = label
    this.modalTarget.style.display = "none"
    this.resetButtonTarget.classList.remove("hidden")
  }

  reset(_) {
    this.searchFieldTarget.value = ""
    this.bookingInputFieldTarget.value = ""
    this.customerFieldTarget.innerHTML = this.customerFieldTarget.dataset.placeholder
    this.searchResultsTarget.classList.add("hidden")
    this.searchIntroTarget.classList.remove("hidden")
    this.resetButtonTarget.classList.add("hidden")
  }

  submitStart() {
    this.searchSpinnerTarget.classList.remove("hidden")
    this.searchIntroTarget.classList.add("hidden")
    this.searchResultsTarget.classList.add("hidden")
  }

  submitEnd() {
    this.searchSpinnerTarget.classList.add("hidden")
    this.searchResultsTarget.classList.remove("hidden")
  }

  search() {
    if (this.searchFieldTarget.value.length < 3) {
      this.searchResultsTarget.classList.add("hidden")
      this.searchIntroTarget.classList.remove("hidden")
      return
    }

    clearTimeout(this.currentTimeout)

    this.currentTimeout = setTimeout(() => { this.formTarget.requestSubmit() }, this.timeoutValue)
  }
}
